const interactiveChapelleInternational = () => {
  let $plan = document.querySelector("#plan");
  let $img = $plan.querySelector("img");
  let width = 523;
  let height = 1040;
  let $inputs = $plan.querySelectorAll('input[type="hidden"]');
  let $canvass = $plan.querySelectorAll("canvas");
  let $descs = document.querySelectorAll("#plan_desc >div");

  let findPos = function(obj) {
    let curleft = 0,
      curtop = 0;
    if (obj.offsetParent) {
      do {
        curleft += obj.offsetLeft;
        curtop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return { x: curleft, y: curtop };
    }
    return undefined;
  };

  $inputs.forEach(function(input, i) {
    let canvas = $canvass.item(i);
    canvas.setAttribute("width", width);
    canvas.setAttribute("height", height);

    let context = canvas.getContext("2d");

    let base_image = new Image();
    base_image.src = input.value;
    base_image.onload = function() {
      context.drawImage(base_image, 0, 0, width, height, 0, 0, width, height);
    };
  });

  let j = 0;

  $plan.addEventListener("mousemove", function(e) {
    let pos = findPos($plan);
    let x = e.pageX - pos.x;
    let y = e.pageY - pos.y;

    // palie le resize du canvas / image
    var ratio = $img.offsetWidth / width;
    x = x / ratio;
    y = y / ratio;
    ////////////////////////////////////

    $canvass.forEach(function(canvas, i) {
      let c = canvas.getContext("2d");
      let p = c.getImageData(x, y, 1, 1).data;

      if (p[3] > 0) j = i;

      canvas.style.opacity = "";
    });

    $descs.forEach(function(desc) {
      desc.classList.remove("visible");
    });

    $canvass.item(j).style.opacity = 1;
    $descs.item(j).classList.add("visible");
  });
};

export default interactiveChapelleInternational;
